// extracted by mini-css-extract-plugin
export var standaloneTable = "_fv-0";
export var withExtraHeader = "_fv-1";